<template>
  <div>
    <div class="wrapper_item" v-if="!key">
      <label for="email" class="wrapper_label">Email</label>
      <input name="email" autocomplete="off" v-model="email" id="email" v-validate="'required|email'" data-vv-validate-on="blur" class="wrapper_input" type="text" @keyup.enter="recover()">
      <span class="text-danger text-sm">{{ errors.first('email') }}</span>
    </div>
    <div class="wrapper_item" v-if="key">
        <app-password label="Новый пароль" v-model="password" v-validate="'required|min:8|max:24|alpha_dash'" data-vv-validate-on="blur"/>
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>
    </div>
    <button class="wrapper_button" @click="recover()">Отправить</button>
    </div>
</template>

<script>

import AppPassword from "@/components/app-password";

export default {
  name: "recover",
  components: { AppPassword },
  data() {
    return {
      email: '',
      key: '',
      password: ''
    }
  },
  mounted() {
    if (this.$route.query.key) {
      this.key = this.$route.query.key;
    }
  },
  methods: {
    recover() {
      if (this.key) {
        this.newPassword()
      } else {
        this.sendLink()
      }
    },
    sendLink() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.$http.post( '/recover-password', { email: this.email })
              .then((response) => {
                if (response.data.success) {
                  this.$toast.success('Ссылка на востановления пароля отправлена на почту!');
                } else {
                  this.$toast.error(response.data.error);
                }
              })
              .catch(()=>{
                this.$toast.error('Что-то пошло не так!');
              })
        }
      })
    },
    newPassword() {
      this.validatePassword();
      if (!this.errors.any()) {
        this.$http.post( '/new-password', {
          password: this.password,
          key: this.key
        }).then((response) => {
          if (response.data.success) {
            this.$toast.success('Пароль успешно изменен');
            this.$router.push({name: 'login'});
          } else {
            this.$toast.error('Ошибка');
          }
        })
        .catch(()=>{
            this.$toast.error('Что-то пошло не так!');
        })
      }
    },
    validatePassword () {
      const chars = this.password.match(/[A-Za-z]/g)
      if (!chars || chars.length < 4) {
        this.errors.add({
          field: 'password',
          msg: 'Поле пароль должно содержать минимум 4 символа латинского алфавита'
        })
      }

      const numbers = this.password.match(/[0-9]/g)
      if (!numbers || numbers.length < 2) {
        this.errors.add({
          field: 'password',
          msg: 'Поле пароль должно содержать минимум 2 цифры'
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
